/**
 * OpenBattleSettings use case: transitions to "settings" scene for the given field.
 * Stores pendingFieldId and initialises/resets the draft StageSettings.
 */

import type { FieldId } from "../../domain/types.js";
import type { RenderPort } from "../ports.js";
import { createDefaultStageSettings, getXpMultiplier, type StageSettings } from "../../domain/stage-settings.js";
import type { GameStateView } from "../ports.js";

export interface OpenBattleSettingsDeps {
  render: RenderPort;
  setPendingFieldId(fieldId: FieldId): void;
  setDraftSettings(settings: StageSettings): void;
  getDraftSettings(): StageSettings;
}

export function createOpenBattleSettings(deps: OpenBattleSettingsDeps) {
  return function openBattleSettings(fieldId: FieldId): void {
    deps.setPendingFieldId(fieldId);
    deps.setDraftSettings(createDefaultStageSettings());
    deps.render.setScene("settings");
    const draft = deps.getDraftSettings();
    const view: GameStateView = {
      scene: "settings",
      settings: {
        fieldId,
        draft,
        xpMultiplier: getXpMultiplier(draft),
      },
    };
    deps.render.update(view);
  };
}
